import AddressEntryFormPrivacy from './AddressEntryFormPrivacy.component';

export default AddressEntryFormPrivacy;